import { LoadState } from "../../../constants/enums";

export interface IFiscalPeriodsState {
  list: IFiscalPeriodList[];
  loading: LoadState;
  totalRecords: number;
  data: IFiscalPeriod[];
  dataLoading: LoadState;
  reopenPreview: IReopenPreview | null;
  reopenPreviewLoading: LoadState;
  recloseProgress: IRecloseRangeResponse | null;
  recloseProgressLoading: LoadState;
  error: string | null;
}

export interface IReopenPreview {
  months: string[];
  summaries: number;
  yearCloses: number;
  fiscal_years_reopened: string[];
}

export interface IRecloseRangeResponse {
  months: Array<{
    fiscal_year_month_code: string;
    ok: boolean;
    error?: string;
  }>;
}

export interface IFiscalPeriodList {
  fiscal_years_code: string | null
}

export interface IFiscalPeriod {
  comment: string | null;
  create_ts: string | null;
  created_by_id: string | null;
  created_by_name: string | null;
  fiscal_year_month_id: string | null;
  from: string | null;
  insert_ts: string | null;
  modified_by_id:string | null;
  modified_by_name:string | null;
  period: string | null;
  fiscal_years_code: string | null;
  status: string | null;
  to: string | null;
  fiscal_year_month_code: string | null;
  year: string | null;
  // Set by the "Continue Without Generating" button on the close confirm
  // dialog; the backend worker reads this and skips PDF generation /
  // fiscal_closing_reports_attachments inserts.
  skip_attachments?: boolean;
}

export const initialFiscalPeriodsState: IFiscalPeriodsState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  data: [],
  dataLoading: LoadState.NotLoaded,
  reopenPreview: null,
  reopenPreviewLoading: LoadState.NotLoaded,
  recloseProgress: null,
  recloseProgressLoading: LoadState.NotLoaded,
  error: null,
};
